import { getScrollbarWidth } from './getScrollBarWidth'

export const scrollbarWidthUnits = () => {
    // First we get the window width
    const sb = getScrollbarWidth()
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--sb', `${sb}px`)
}
